module.exports = __webpack_public_path__ + "img/appImage-customer-base--2.270bf08b.svg";